import { ReactElement } from "react";
import { Box } from "@mui/material";
import { ErrorBoundary } from "@platform/design-system";

import { PolicyVariants } from "../../constants";
import { Policy } from "../../constants/aquafina";

import CoverageSubheader from "./coverage-subheader";
import CoverageInformation from "./coverage-information";

type PolicyFullscreenProps = {
  policyDetailsInfo: Policy;
  variant: PolicyVariants;
  subTitleText?: ReactElement<unknown>;
  groupName: string;
  carrierName: string;
  coverageName: string;
};

const PolicyFullscreen = ({
  policyDetailsInfo,
  variant,
  subTitleText,
  groupName,
  carrierName,
  coverageName,
}: PolicyFullscreenProps) => (
  <ErrorBoundary>
    <div>
      <CoverageSubheader
        groupName={groupName}
        carrier={carrierName}
        coverage={coverageName}
        subTitleText={subTitleText}
        sticky={true}
      />
      <Box sx={{ paddingTop: 24 }}>
        <CoverageInformation
          policyDetailsInfo={policyDetailsInfo}
          variant={variant}
        />
      </Box>
    </div>
  </ErrorBoundary>
);

export default PolicyFullscreen;
